module.exports = __webpack_public_path__ + "static/media/lincoln.147bde73.svg";